import React, { useState, useEffect } from "react";
import { publicRequest } from "../requestMethods"; // ajuste conforme seu projeto

const CompanySelect = ({ onSelect }) => {
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");

  // Buscar empresas ao montar o componente
  useEffect(() => {
    const getCompanies = async () => {
      try {
        const res = await publicRequest.get(`/company`);
        setCompanies(res.data);
      } catch (err) {
        console.error("Erro ao buscar empresas:", err);
      }
    };
    getCompanies();
  }, []);

  const handleChangeCompany = (e) => {
    const companyId = e.target.value;
    setSelectedCompany(companyId);
    if (onSelect) onSelect(companyId); // retorna para o componente pai
  };

  return (
    <div className="div_custom_UpdateList">
      <label>Empresas</label>
      <select
        className="div_custom_Select"
        name="company"
        value={selectedCompany}
        onChange={handleChangeCompany}
      >
        <option value="">Selecione</option>
        {companies.map((item) => (
          <option key={item.companyId} value={item.companyId}>
            {item.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CompanySelect;
